import { render, staticRenderFns } from "./baseModal.vue?vue&type=template&id=f31ad47c&"
import script from "./baseModal.vue?vue&type=script&lang=js&"
export * from "./baseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports